export default {
  getterLoggedUser: state => state.loggedUser,
  getterLoggedUserType: state => state.loggedUserType,
  getterLoggedUserToken: state => state.loggedUserToken,

  getterUserPrefferenceByPath: state => (path) => {
    return Object.byString(state.user_preferences, path) ?? null
  },
  
  lastJurisdictionVisited: state => state?.user_preferences?.lastJurisdictionVisited ?? null,
  lastClimateZonesVisited: state => state?.user_preferences?.lastClimateZonesVisited ?? null,
  lastClimateZoneVisited(state) {
    const climate_zone = state?.user_preferences?.lastClimateZonesVisited?.[0]
    if(!climate_zone) return null
    if(state?.user_preferences?.lastJurisdictionVisited?.climate_zones?.findInArray({ raw: climate_zone.raw })) {
      return climate_zone
    }
    return state?.user_preferences?.lastJurisdictionVisited?.climate_zones[0]
  },

  hasVisitedModule: state => (module) => {
    return state.user_preferences?.modulesVisited?.includes(module) ? true : false
  },

  isUserLoggedIn(state) {
    return state?.loggedUser ?? null
  }
}